import styled from "@emotion/styled";

const CustomersPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export default CustomersPageWrapper
